export default function Loading({ color = 'text-gray' }) {
	return (
		<div class="w-full flex justify-center bg-light-gray bg-opacity-40 py-12 rounded-md">
			<div class="text-center">
				<p class="font-display text-3xl font-bold mb-4">Laster...</p>
				<div
					class={`inline-block w-32 animate-pulse ${
						color ? color : ''
					}`}
				>
					<Fish />
				</div>
			</div>
		</div>
	);
}

function Fish() {
	return (
		<svg viewBox="0 0 71 26" xmlns="http://www.w3.org/2000/svg">
			<path
				d="m17.141 13.062c0.8627-1.4635 10.625-12.12 23.93-12.12 19.661-1e-6 28.47 10.656 29.56 12.12l0.0455 0.0914-0.0455 0.0915c-1.0897 1.4635-9.8987 12.12-29.56 12.12-13.304 0-23.067-10.656-23.93-12.12l-0.0454-0.0915 0.0454-0.0914zm50.947 0.1829c0-1.0062-0.8174-1.8294-1.8163-1.8294-0.999 0-1.8163 0.8232-1.8163 1.8294s0.8173 1.8294 1.8163 1.8294c0.9989 0 1.8163-0.8232 1.8163-1.8294zm-67.111 5.3967 13.395-5.5797-13.395-5.5796v11.159z"
				clipRule="evenodd"
				fillRule="evenodd"
				class="fill-current"
			/>
		</svg>
	);
}
